var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-input.ts
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-formfield-wrapper.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { XPlainInput } from "./x-plain-input.js";
var XInput = class extends XPlainInput {
  constructor() {
    super(...arguments);
    this.icon = "";
    this.clearable = false;
    this.postfix = "";
    this.bold = false;
    this["no-password-toggle"] = false;
    this.isPasswordInput = false;
  }
  get inputToken() {
    return inputToken(this);
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          height: "unset",
          fontSize: this.baseFontSize,
          cursor: "text"
        }
      }
    ];
  }
  get _showLabel() {
    return this.value.value !== void 0 && this.value.value !== null && this.value.value !== "" || !!this.error;
  }
  render() {
    return xComponents(html`
      <x-formfield-wrapper
        one-line
        ?show-label=${this._showLabel}
        ${injectAttributesOf(this, ["icon", "error"])}
        error=${ifDefined(this.error)}
        icon=${this.icon || (this.type === "password" && !this["no-password-toggle"] ? "visibility_off" : this.isPasswordInput ? "visibility" : "")}
        @cleared=${() => {
      this.processNewValue("");
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
      this.dispatchEvent(new CustomEvent("cleared"));
    }}
        @icon-click=${() => {
      if (!this.icon && (this.type === "password" || this.isPasswordInput)) {
        if (this.type === "text" && this.isPasswordInput)
          this.type = "password";
        else if (this.type === "password") {
          this.isPasswordInput = true;
          this.type = "text";
        }
      }
      this.dispatchEvent(new CustomEvent("icon-click"));
    }}
      >
        <x-text flex ?bold=${this.bold}> ${super.render()} </x-text>
      </x-formfield-wrapper>
    `);
  }
};
__decorateClass([
  property({ attribute: true })
], XInput.prototype, "icon", 2);
__decorateClass([
  property({ type: Boolean, attribute: true })
], XInput.prototype, "clearable", 2);
__decorateClass([
  property({ attribute: true })
], XInput.prototype, "postfix", 2);
__decorateClass([
  property({ type: Boolean, attribute: true })
], XInput.prototype, "bold", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], XInput.prototype, "no-password-toggle", 2);
__decorateClass([
  state()
], XInput.prototype, "isPasswordInput", 2);
XInput = __decorateClass([
  customElement("x-input")
], XInput);
export {
  XInput
};
